import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, defaultValue, value, ...props }, ref) => {
  // Determine number of thumbs based on value or defaultValue array length
  const values = value || defaultValue || [0];
  const thumbCount = Array.isArray(values) ? values.length : 1;
  
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn("relative flex w-full touch-none select-none items-center py-4", className)}
      defaultValue={defaultValue}
      value={value}
      {...props}
    >
      <SliderPrimitive.Track
        className="relative h-3 w-full grow overflow-hidden rounded-full bg-white/10 cursor-pointer"
      >
        <SliderPrimitive.Range className="absolute h-full bg-gradient-to-r from-gold-dark to-gold" />
      </SliderPrimitive.Track>
      {/* Render thumbs with larger touch target */}
      {Array.from({ length: thumbCount }).map((_, index) => (
        <SliderPrimitive.Thumb
          key={index}
          className={cn(
            "block h-7 w-7 rounded-full border-2 border-gold bg-dark-paper",
            "shadow-lg shadow-gold/30",
            "ring-0 outline-none",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold",
            "focus-visible:ring-offset-2 focus-visible:ring-offset-dark",
            "disabled:pointer-events-none disabled:opacity-50",
            "hover:bg-gold hover:scale-110 hover:border-gold-light",
            "cursor-grab active:cursor-grabbing active:scale-95 active:bg-gold",
            "transition-all duration-150 ease-out",
            // Add a larger invisible touch target
            "before:absolute before:inset-[-8px] before:content-['']"
          )}
          style={{ 
            zIndex: 20,
            touchAction: 'none'
          }}
        />
      ))}
    </SliderPrimitive.Root>
  );
})
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
